import { useNavigate } from 'react-router-dom';
import { Badge, Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { FaShoppingCart, FaUser } from 'react-icons/fa';
import { LinkContainer } from 'react-router-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import logo from '../assets/logo.png';
import { resetCart } from '../slices/cartSlice.js';

const Header = () => {
  const { cartItems } = useSelector((state) => state.cart)
  // console.log(cartItems); //check whether you can see items in cart in browser console 
  const { userInfo } = useSelector((state) => state.auth)
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(resetCart());
      navigate("login");
    } catch(err) {
      console.log(err);
    }
  };

  return (
    <header>
      <Navbar bg="dark" variant="dark" expand="md" collapseOnSelect>
        <Container>
          <LinkContainer to="/">
          <Navbar.Brand>
            <img src={logo} alt="小馬麻手作烘焙坊" className="brand-logo" />
          </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic.navbar-nav">
            <Nav className="ms-auto">
              <LinkContainer to="/">
              <Nav.Link>
                <FaShoppingCart /> 購物車
                {
                  cartItems.length > 0 && (
                    <Badge pill bg="warning" style={{marginLeft: '5px'}}>
                      { cartItems.reduce((a, c) => a + c.qty, 0 )}
                    </Badge>
                  )
                }
              </Nav.Link>
              </LinkContainer>
              { userInfo ? (
                <NavDropdown title={userInfo.name} id="username">
                  <LinkContainer to="/profile">
                    <NavDropdown.Item>個人資料</NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Item onClick={logoutHandler}>
                    登出
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (<LinkContainer to="/login">
              <Nav.Link>
                <FaUser /> 登入
              </Nav.Link>
              </LinkContainer>) }
              
              {userInfo && userInfo.isAdmin && (
                <NavDropdown title="管理後台" id="adminmenu">
                  <LinkContainer to="/admin/productlist">
                    <NavDropdown.Item>商品管理</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/admin/userlist">
                    <NavDropdown.Item>會員管理</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/admin/orderlist">
                    <NavDropdown.Item>訂單管理</NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  )
}

export default Header;